import { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Headline } from '@gaiads/telia-react-component-library';
import { ProductOrder } from '@cdaas/api-clients/dist/order-openapi';

import { authSetPendingApprovals, showGrowlNotification } from '../../store/actions';
import { getOrdersPendingInApproval } from '../../utils';
import ApprovalList from './ApprovalList';

const Approval: FunctionComponent = () => {
  const [approvals, setApprovals] = useState<ProductOrder[]>([]);
  const { t } = useTranslation('approval');
  const dispatch = useDispatch();

  const getOrderApprovals = async (): Promise<void> => {
    const approvals = await getOrdersPendingInApproval();
    if (!approvals) {
      dispatch(showGrowlNotification(t('getApprovalsError'), 'warning'));
      return;
    }
    setApprovals(approvals.contents);
    dispatch(authSetPendingApprovals(approvals.page_metadata.total_items));
  };

  useEffect(() => {
    getOrderApprovals();
    // not adding getOrderApprovals as dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Headline size={'lg'} margin={{ vertical: 'xlg' }}>
        {t('approvalTitle')}
      </Headline>
      <ApprovalList approvals={approvals} getOrderApprovals={getOrderApprovals} />
    </>
  );
};

export default Approval;
